import { useContext } from "react";
import SelectedGroupContext from "src/contexts/SelectedGroupContext";

const useSelectedGroup = () => useContext(SelectedGroupContext);

export default useSelectedGroup;
